import 'date-fns'
import React from 'react'
import { connect } from 'react-redux'
import { 
    Box, 
    Grid, 
    Button,
    FormControl,
    Select,
    MenuItem,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
    RadioGroup,
    Radio,
    TextField,
    Snackbar
} from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import AlarmIcon from '@material-ui/icons/Alarm';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns'
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers'

import {rgbaFormat} from '../components/ColorPicker'

import {
    onChangeCheckboxAction, 
    onDropdownChooseAction, 
    onRadioChooseAction, 
    onTextChangeAction, 
    onDateChangeAction, 
    onClickSubmitAction,
    onSubmitResponseAction
} from '../actions/form'


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const EmazeForm = ({settings, design, form, isPreview,
    onChangeCheckbox, 
    onDropdownChoose, 
    onRadioChoose,
    onTextChange,
    onDateChange,
    onClickSubmit,
    onSubmitResponse
}) => {
    let formStyle = {
        borderRadius: design.layout.borderRadius,
        backgroundColor: rgbaFormat(design.backgrounds.color),
    },        
    submitStyle = {
        fontFamily: design.fonts.button.font.value,
        fontSize: design.fonts.button.size,
        color: rgbaFormat(design.fonts.button.color),
        backgroundColor: rgbaFormat(design.submit.bgColor),
        borderRadius: design.submit.borderRadius,
        textTransform: 'initial'
    }    

    if(isPreview){
        formStyle.width = '125%';
        formStyle.overflow = 'hidden';
        formStyle.overflowY = 'auto';
        formStyle.maxHeight = 550;
    }

    /** Label Style */
    switch(design.layout.labelStyle){
        case "inline":
            break;
        case "block":
            break;
        default:
            break;
    }
    
    const styles = makeStyles({
        root:{
            textAlign: design.layout.textAlign,
            fontFamily: design.fonts.title.font.value,
            fontSize: design.fonts.title.size,
            color: rgbaFormat(design.fonts.title.color)
        },
        formTitle:{
            textAlign: design.layout.textAlign,
            fontFamily: design.fonts.title.font.value,
            fontSize: design.fonts.title.size,
            color: rgbaFormat(design.fonts.title.color)
        },
        formControl: {
            width: '100%'
        },
        formLabel: {
            fontFamily: design.fonts.label.font.value,
            fontSize: design.fonts.label.size,
            color: rgbaFormat(design.fonts.label.color)
        },
        textField:{
            '& .MuiInputBase-root':{
                backgroundColor: rgbaFormat(design.backgrounds.inputColor),
                borderRadius: design.layout.fieldBorderRadius,
                marginTop: 16,
                paddingLeft: 10,
                paddingRight: 10
            },
            '& .MuiInputBase-input':{
                fontFamily: design.fonts.input.font.value,
                fontSize: design.fonts.input.size,
                color: rgbaFormat(design.fonts.input.color)
            },
            '& .MuiInput-underline:before':{
                borderBottom: 'none'
            },
            '& .MuiInput-underline:after':{
                borderBottom: 'none'
            },
            '& .MuiInput-underline:hover:not(.Mui-disabled):before':{
                borderBottom: 'none'
            }                     
        },
        select:{
            fontFamily: design.fonts.input.font.value,
            fontSize: design.fonts.input.size,
            color: rgbaFormat(design.fonts.input.color),
            backgroundColor: rgbaFormat(design.backgrounds.inputColor),
            borderRadius: design.layout.fieldBorderRadius,
            paddingLeft: 10,
            paddingRight: 10,
            '&.MuiInput-underline:before':{
                borderBottom: 'none'
            },
            '&.MuiInput-underline:after':{
                borderBottom: 'none'
            },
            '&.MuiInput-underline:hover:not(.Mui-disabled):before':{
                borderBottom: 'none'
            }
        },
        formControlLabel:{
            '& .MuiTypography-body1':{
                fontFamily: design.fonts.input.font.value,
                fontSize: design.fonts.input.size,
                color: rgbaFormat(design.fonts.input.color)
            },
            fontFamily: design.fonts.input.font.value,
            fontSize: design.fonts.input.size,
            color: rgbaFormat(design.fonts.input.color)
        },
        checkBoxOrRadio:{            
            fontFamily: design.fonts.input.font.value,
            fontSize: design.fonts.input.size,
            color: rgbaFormat(design.backgrounds.inputColor)
        },
        checkBoxOrRadioIcon:{
            color: rgbaFormat(design.fonts.input.color)
        },
        dateTimePicker:{
            fontFamily: design.fonts.input.font.value,
            fontSize: design.fonts.input.size,
            color: rgbaFormat(design.fonts.input.color),
            backgroundColor: rgbaFormat(design.backgrounds.inputColor),
            borderRadius: design.layout.fieldBorderRadius,
            paddingLeft: 10,
            paddingRight: 10,
            '& input': {
                fontFamily: design.fonts.input.font.value,
                fontSize: design.fonts.input.size,
                color: rgbaFormat(design.fonts.input.color)
            },
            '& .MuiInput-underline:before':{
                borderBottom: 'none'
            },
            '& .MuiInput-underline:after':{
                borderBottom: 'none'
            },
            '& .MuiInput-underline:hover:not(.Mui-disabled):before':{
                borderBottom: 'none'
            }
        }
    })()
    
    const handleCheckboxOnChange = (event, e_id, o_id) => {
        if(!isPreview)
            onChangeCheckbox(e_id, o_id)
    }

    const handleDropdownChoose = (event, e_id) => {
        if(!isPreview)
            onDropdownChoose(e_id, event.target.value)
    }

    const handleRadioChoose = (event, e_id) => {
        if(!isPreview)
            onRadioChoose(e_id, event.target.value)
    }

    const handleTextChange = (event, e_id) => {
        if(!isPreview)
            onTextChange(e_id, event.target.value)
    }

    const handleDateChange = (date, e_id) => {
        if(!isPreview)
            onDateChange(date, e_id)
    }

    const handleClickSubmit = (event, formId, presId, settings) => {
        if(!isPreview)
            onClickSubmit(formId, presId, settings)
    }

    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        onSubmitResponse("close", null)
    }

    const snackbarOrigin = { vertical:'top', horizontal:'center'};

    return(
        <Box>
         
            <form style={formStyle}>
                <Box p="15px">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box className={styles.formTitle}>{settings.title}</Box>
                        </Grid>
                        {
                            settings.elements.map((elm) => {
                                let col = elm.isHalf ? 6 : 12
                                if(elm.name === 'separator'){
                                    return(
                                        <Grid key={elm.id} item xs={12}></Grid>
                                    )
                                }else{
                                    return(
                                        <Grid key={elm.id} item xs={col}>
                                            <FormControl className={styles.formControl}>
                                                <FormLabel className={styles.formLabel}>{elm.label}</FormLabel>
                                                {(() => {
                                                    switch(elm.name){                                                
                                                        case 'input':                                    
                                                            return(
                                                                <TextField required={elm.isRequired}  className={styles.textField} onChange={(e) => handleTextChange(e, elm.id)} value={elm.value}></TextField>
                                                            )
                                                        case 'textaria':
                                                            return(
                                                                <TextField required={elm.isRequired} type="textaria" className={styles.textField} onChange={(e) => handleTextChange(e, elm.id)} minRows={5} multiline={true} value={elm.value}></TextField>
                                                            )
                                                        case 'dropdown':
                                                            return(
                                                                <Select required={elm.isRequired} className={styles.select} value={elm.value} onChange={(event) => handleDropdownChoose(event, elm.id)}>
                                                                    {
                                                                        elm.options.map((o) => {
                                                                            return (
                                                                                <MenuItem key={o.id} value={o.value}>{o.value}</MenuItem>
                                                                            )
                                                                        })
                                                                    }
                                                                </Select>
                                                            )
                                                        case 'checklist':
                                                            return(
                                                                <FormGroup row={true}>
                                                                    {
                                                                        elm.options.map((option) => {
                                                                            return(
                                                                                <FormControlLabel
                                                                                    key={option.id}
                                                                                    className={styles.formControlLabel}
                                                                                    control={<Checkbox className={styles.checkBoxOrRadio} checked={option.checked}
                                                                                        checkedIcon={<CheckBoxIcon className={styles.checkBoxOrRadioIcon} />} 
                                                                                        onChange={(event) => handleCheckboxOnChange(event, elm.id, option.id)} 
                                                                                        value={option.value} />}
                                                                                    label={option.value}
                                                                                ></FormControlLabel>
                                                                            )
                                                                        })
                                                                    }
                                                                </FormGroup>
                                                            )
                                                        case 'radio':
                                                            return(
                                                                <RadioGroup value={elm.value} onChange={(e) => handleRadioChoose(e, elm.id)}>
                                                                    {
                                                                        elm.options.map((option) => {
                                                                            return(
                                                                                <FormControlLabel
                                                                                    key={option.id}
                                                                                    className={styles.formControlLabel}
                                                                                    value={option.value}
                                                                                    control={<Radio className={styles.checkBoxOrRadio} checkedIcon={<RadioButtonCheckedIcon className={styles.checkBoxOrRadioIcon} />}></Radio>}
                                                                                    label={option.value}
                                                                                >
                                                                                </FormControlLabel>
                                                                            )
                                                                        })
                                                                    }                                                                
                                                                </RadioGroup>
                                                            )
                                                        case 'counter':
                                                            return(
                                                                <TextField value={elm.value} type="number" className={styles.textField} onChange={(e) => handleTextChange(e, elm.id)}></TextField>
                                                            )
                                                        case 'date':
                                                            return(
                                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                    <KeyboardDatePicker
                                                                        margin="normal"
                                                                        id={`date-picker-${elm.id}`}                                                    
                                                                        format="MM/dd/yyyy"
                                                                        value={elm.value}
                                                                        onChange={(date) => handleDateChange(date, elm.id)}
                                                                        className={styles.dateTimePicker}
                                                                        KeyboardButtonProps={{
                                                                            'aria-label': 'change date',
                                                                            style: {
                                                                                fontSize: design.fonts.input.size,
                                                                                color: design.fonts.input.color                                                                            
                                                                            }
                                                                        }}
                                                                    />
                                                                </MuiPickersUtilsProvider>
                                                            )
                                                        case 'time':
                                                            return(
                                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                    <KeyboardTimePicker
                                                                        margin="normal"
                                                                        id={`time-picker-${elm.id}`}                                                
                                                                        value={elm.value}
                                                                        onChange={(date) => handleDateChange(date, elm.id)}
                                                                        className={styles.dateTimePicker}
                                                                        KeyboardButtonProps={{
                                                                            'aria-label': 'change time',
                                                                            style: {
                                                                                fontSize: design.fonts.input.size,
                                                                                color: design.fonts.input.color
                                                                            }
                                                                        }} 
                                                                        keyboardIcon={<AlarmIcon />}
                                                                    />
                                                                </MuiPickersUtilsProvider>
                                                            )
                                                        default:
                                                            break;
                                                    }
                                                })()}
                                            </FormControl>
                                        </Grid>
                                    )
                                }                            
                            })
                        }
                        <Grid item xs={12}>
                            <Box style={{textAlign: design.submit.alignment}}>
                                <Button style={submitStyle} onClick={(e) => handleClickSubmit(e, form.id, form.presId, settings)}>{settings.submitText}</Button>
                            </Box>
                        </Grid>
                    </Grid>                               
                </Box>
            </form>
            <Snackbar 
                anchorOrigin={snackbarOrigin}
                key={'success_snackbar'}
                autoHideDuration={5000}
                open={form.snackbarOpenSuccess}
                onClose={handleCloseSnackBar}
                style={{top: 8, bottom: 8}}
            >
                <Alert onClose={handleCloseSnackBar} severity="success">
                    {settings.successMessage}
                </Alert>
            </Snackbar>
            <Snackbar 
                anchorOrigin={snackbarOrigin}
                key={'error_snackbar'}
                autoHideDuration={5000}
                open={form.snackbarOpenError}
                onClose={handleCloseSnackBar}
                style={{top: 8, bottom: 8}}
            >
                <Alert onClose={handleCloseSnackBar} severity="error">
                    {settings.errorMessage}
                </Alert>
            </Snackbar>
        </Box>
    )
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    onChangeCheckbox: (e_id, o_id) => dispatch(onChangeCheckboxAction(e_id, o_id)),
    onDropdownChoose: (e_id, value) => dispatch(onDropdownChooseAction(e_id, value)),
    onRadioChoose: (e_id, value) => dispatch(onRadioChooseAction(e_id, value)),
    onTextChange: (e_id, value) => dispatch(onTextChangeAction(e_id, value)),
    onDateChange: (date, e_id) => dispatch(onDateChangeAction(e_id, date)),
    onClickSubmit: (formId, presId, settings) => dispatch(onClickSubmitAction(formId, presId, settings)),
    onSubmitResponse: (status, data) => dispatch(onSubmitResponseAction(status, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(EmazeForm)